export const authApplications = {
  LOGIN: 'login',
  RESET_PASSWORD: 'resetPassword',
  SET_PASSWORD: 'setPassword',
};

export const paymentActionTypes = {
  GET_LIST: 'GET_LIST',
  SET_LIST: 'SET_LIST',
  GET_LIST_CS: 'GET_LIST_COMMUNICATION_STATUS',
  SET_SETUP: 'SET_SETUP',
  SET_SELECTED_PROPERTY_IDS: 'SET_SELECTED_PROPERTY_IDS',
  CREATE_CONNECTED_ACCOUNT_CS: 'CREATE_CONNECTED_ACCOUNT_COMMUNICATION_STATUS',
  SET_CONNECTED_ACCOUNT_ID: 'SET_CONNECTED_ACCOUNT_ID',
  UPDATE_PAYMENT_DEPOSIT_RULES: 'UPDATE_PAYMENT_DEPOSIT_RULES',
  UPDATE_PAYMENT_FIRST_INSTALMENT: 'UPDATE_PAYMENT_FIRST_INSTALMENT',
  SKIP_PAYMENT_FIRST_INSTALMENT: 'SKIP_PAYMENT_FIRST_INSTALMENT',
  UPDATE_TERMS_AND_CONDITIONS: 'UPDATE_TERMS_AND_CONDITIONS',
  UPDATE_PAYMENT_PROCESS: 'UPDATE_PAYMENT_PROCESS',
  UPDATE_PAYMENT_ENABLED: 'UPDATE_PAYMENT_ENABLED',
  RESET_PAYMENT: 'RESET_PAYMENT',
  GET_STRIPE_CLIENT_ID_CS: 'GET_STRIPE_CLIENT_ID_COMMUNICATION_STATUS',
  SET_STRIPE_CLIENT_ID: 'SET_STRIPE_CLIENT_ID',
  GET_LONG_TAIL_PAYMENT_PLAN_CS: 'GET_LONG_TAIL_PAYMENT_PLANCOMMUNICATION_STATUS',
  CREATE_LONG_TAIL_PAYMENT_PLAN_CS: 'CREATE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  DELETE_LONG_TAIL_PAYMENT_PLAN_CS: 'DELETE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  UPDATE_LONG_TAIL_PAYMENT_PLAN_CS: 'UPDATE_LONG_TAIL_PAYMENT_PLAN_COMMUNICATION_STATUS',
  SET_LONG_TAIL_PAYMENT_PLAN: 'SET_LONG_TAIL_PAYMENT_PLAN',
  RESET_LONG_TAIL_PAYMENT_PLAN: 'RESET_LONG_TAIL_PAYMENT_PLAN',
  GET_LONG_TAIL_INSTALMENT_PLAN_CS: 'GET_LONG_TAIL_INSTALMENT_PLANCOMMUNICATION_STATUS',
  CREATE_LONG_TAIL_INSTALMENT_PLAN_CS: 'CREATE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  DELETE_LONG_TAIL_INSTALMENT_PLAN_CS: 'DELETE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  UPDATE_LONG_TAIL_INSTALMENT_PLAN_CS: 'UPDATE_LONG_TAIL_INSTALMENT_PLAN_COMMUNICATION_STATUS',
  CREATE_ORDER_DEPOSIT_CS: 'CREATE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  UPDATE_ORDER_DEPOSIT_CS: 'UPDATE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  DELETE_ORDER_DEPOSIT_CS: 'DELETE_ORDER_DEPOSIT_COMMUNICATION_STATUS',
  CREATE_ORDER_FEE_CS: 'CREATE_ORDER_FEE_COMMUNICATION_STATUS',
  UPDATE_ORDER_FEE_CS: 'UPDATE_ORDER_FEE_COMMUNICATION_STATUS',
  DELETE_ORDER_FEE_CS: 'DELETE_ORDER_FEE_COMMUNICATION_STATUS',
  GET_LONGTAIL_PAYMENT_PLANS_CS: 'GET_LONGTAIL_PAYMENT_PLANS_COMMUNICATION_STATUS',
  SET_LONGTAIL_PAYMENT_PLANS: 'SET_LONGTAIL_PAYMENT_PLANS',
};

export const propertiesActionTypes = {
  GET_PROPERTIES: 'GET_PROPERTIES',
  SET_PROPERTIES: 'SET_PROPERTIES',
  GET_PROPERTIES_CS: 'GET_PROPERTIES_CS',
  GET_LISTINGS: 'GET_LISTINGS',
  SET_LISTINGS: 'SET_LISTINGS',
  GET_LISTINGS_CS: 'GET_LISTINGS_CS',
  UPDATE_LISTING_CS: 'UPDATE_LISTING_CS',
};

export const bookingsActionTypes = {
  GET_BOOKINGS_LIST_CS: 'GET_BOOKINGS_LIST_CS',
  SET_BOOKINGS_LIST: 'SET_BOOKINGS_LIST',
  GET_BOOKINGS_SUMMARY_CS: 'GET_BOOKINGS_SUMMARY_CS',
  SET_BOOKINGS_SUMMARY: 'SET_BOOKINGS_SUMMARY',
  GET_BOOKINGS_PROPERTIES_LIST_CS: 'GET_BOOKINGS_PROPERTIES_LIST_CS',
  SET_BOOKINGS_PROPERTIES_LIST: 'SET_BOOKINGS_PROPERTIES_LIST',
  UPDATE_BOOKINGS_CONFIRM_CS: 'UPDATE_BOOKINGS_CONFIRM_CS',
  SET_BOOKINGS_REJECT_CS: 'SET_BOOKINGS_REJECT_CS',
  CREATE_BOOKING_COMMENT_CS: 'CREATE_BOOKING_COMMENT_CS',
  UPDATE_BOOKING_STATUS_CS: 'UPDATE_BOOKING_STATUS_CS',
  EXPORT_LIST_CS: 'EXPORT_LIST_CS',
  BATCH_UPDATE_BOOKING_STATUS_CS: 'BATCH_UPDATE_BOOKING_STATUS_CS',
  GET_LONGTAIL_BOOKING_CS: 'GET_LONGTAIL_BOOKING_CS',
  SET_LONGTAIL_BOOKING: 'SET_LONGTAIL_BOOKING',
};

export const authActionTypes = {
  INITIALIZE: 'initialize',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOGGED_IN: 'LOGGED_IN',
  SET_USER_AUTH: 'SET_USER_AUTH',
  SET_USER_ROLE: 'SET_USER_ROLE',
  SET_USER_AUTH_LIST: 'SET_USER_AUTH_LIST',
  GET_USER_AUTH_CS: 'GET_USER_AUTH_CS',
  UPDATE_COMMUNICATION_STATUS: 'UPDATE_COMMUNICATION_STATUS',
  EMAIL_RESET_SUCCESSFUL: 'EMAIL_RESET_SUCCESSFUL',
  LOGIN_IN_CS: 'LOGIN_IN_CS',
  SET_CONTACTS: 'SET_CONTACTS',
  SET_LANDLORD_TYPE: 'SET_LANDLORD_TYPE',
  GET_LANDLORD_TYPE_CS: 'GET_LANDLORD_TYPE_CS',
  SET_LANDLORD_PROPERTIES: 'SET_LANDLORD_PROPERTIES',
  SET_LANDLORD_NAME: 'SET_LANDLORD_NAME',
};

export const propertyListActionTypes = {
  INITIALIZE: 'INITIALIZE_PROPERTY_LIST',
  SET_LIST: 'SET_PROPERTY_LIST',
  LIST_CS: 'GET_LIST_PROPERTY_LIST_COMMUNICATION_STATUS',
  SET_PROPERTY_IN_LIST: 'SET_PROPERTY_IN_LIST',
  CREATE_PROPERTY_CS: 'CREATE_PROPERTY_CS',
  UPDATE_PROPERTY_RECORD_NOTE_CS: 'UPDATE_PROPERTY_NOTE_CS',
  EDIT_PROPERTY_RECORD_NOTE_CS: 'EDIT_PROPERTY_NOTE_CS',
  DELETE_PROPERTY_RECORD_NOTE_CS: 'DELETE_PROPERTY_NOTE_CS',
};

export const awsTokenActionType = {
  GET_UPLOAD_VIDEO_TOKEN: 'GET_UPLOAD_VIDEO_TOKEN',
  CHECK_VIDEO_UPLOADED: 'CHECK_VIDEO_UPLOADED',
  CREATE_VIDEO: 'CREATE_VIDEO',
};

export const landlordInfoActionTypes = {
  SET_INFO: 'SET_INFO',
  GET_CS: 'GET_CS',
  UPDATE_CS: 'UPDATE_CS',
};

export const offerListActionTypes = {
  INITIALIZE: 'INITIALIZE_OFFER_LIST',
  SET_LIST: 'SET_OFFER_LIST',
  LIST_CS: 'GET_LIST_OFFER_LIST_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_OFFER_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_OFFER_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_OFFER_COMMUNICATION_STATUS',
  SET_OPERATING_OFFER: 'SET_OPERATING_OFFER',
};

export const offerMapActionTypes = {
  INITIALIZE: 'INITIALIZE_MAP_PROPERTY',
  SET_LIST: 'SET_MAP_PROPERTY_LIST',
  LINK_CS: 'LINK_MAP_LIST_COMMUNICATION_STATUS',
  UNLINK_CS: 'UNLINK_MAP_LIST_COMMUNICATION_STATUS',
  LIST_CS: 'GET_LIST_MAP_PROPERTY_COMMUNICATION_STATUS',
};

export const roomListingsActionTypes = {
  INITIALIZE: 'INITIALIZE_ROOM_LISTINGS',
  SET_LIST: 'SET_ROOM_LISTINGS_LIST',
  SET_CHECKED_ROW_KEYS: 'SET_CHECKED_ROW_KEYS',
  SET_UPDATED_ROW_KEY: 'SET_UPDATED_ROW_KEY',
  LIST_CS: 'GET_LIST_ROOM_LISTINGS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_LISTING_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_LISTING_COMMUNICATION_STATUS',
  DELETE_CS: 'REMOVE_ROOM_LISTING_COMMUNICATION_STATUS',
};

export const unitTypesActionTypes = {
  INITIALIZE: 'INITIALIZE_UNIT_TYPES',
  SET_LIST: 'SET_UNIT_TYPES_LIST',
  LIST_CS: 'GET_LIST_UNIT_TYPES_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_UNIT_TYPE_COMMUNICATION_STATUS',
};

export const classificationsActionTypes = {
  INITIALIZE: 'INITIALIZE_CLASSIFICATIONS',
  SET_LIST: 'SET_CLASSIFICATIONS_LIST',
  LIST_CS: 'GET_LIST_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_CLASSIFICATIONS_COMMUNICATION_STATUS',
  DISTINCTION_TO_UNIT_TYPE_CS:
    'ADD_OR_REMOVE_ROOM_CLASSIFICATION_TO_UNIT_TYPES_COMMUNICATION_STATUS',
  UPDATE_LIST_ITEM: 'UPDATE_ROOM_CLASSIFICATION_ITEM',
};

export const distinctionsActionTypes = {
  INITIALIZE: 'INITIALIZE_DISTINCTIONS',
  SET_LIST: 'SET_DISTINCTIONS_LIST',
  LIST_CS: 'GET_LIST_DISTINCTIONS_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_ROOM_DISTINCTIONS_COMMUNICATION_STATUS',
  DISTINCTION_TO_UNIT_TYPE_CS: 'ADD_OR_REMOVE_ROOM_DISTINCTIONS_TO_UNIT_TYPES_COMMUNICATION_STATUS',
  UPDATE_LIST_ITEM: 'UPDATE_ROOM_DISTINCTION_ITEM',
};

export const udeskActionTypes = {
  GET_STUDENT_CS: 'GET_STUDENT_CS',
  SET_STUDENT: 'SET_STUDENT',
  SET_PARTNER: 'SET_PARTNER',
};

export const countryActionTypes = {
  INITIALIZE: 'INITIALIZE_COUNTRY_LIST',
  SET_LIST: 'SET_COUNTRY_LIST',
  LIST_CS: 'GET_LIST_COUNTRY_LIST_COMMUNICATION_STATUS',
};

export const cityActionTypes = {
  CHECK_CITY_EXIST: 'CHECK_CITY_EXIST',
  SET_CITY_DETAIL: 'SET_CITY_DETAIL',
  SET_CITY_BASE: 'SET_CITY_BASE',
  GET_CITY_DETAIL: 'GET_CITY_DETAIL',
  GET_CITY_DETAIL_CS: 'GET_CITY_DETAIL_COMMUNICATION_STATUS',
  INITIALIZE: 'INITIALIZE_CITY_LIST',
  SET_LIST: 'SET_CITY_LIST',
  LIST_CS: 'GET_LIST_CITY_LIST_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_CITY_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_CITY_COMMUNICATION_STATUS',
};

export const universityActionTypes = {
  INITIALIZE: 'INITIALIZE_UNIVERSITY_LIST',
  SET_LIST: 'SET_UNIVERSITY_LIST',
  LIST_CS: 'GET_LIST_UNIVERSITY_LIST_COMMUNICATION_STATUS',
  SET_UNIVERSITY_DETAIL: 'SET_UNIVERSITY_DETAIL',
  SET_UNIVERSITY_BASE: 'SET_UNIVERSITY_BASE',
  GET_UNIVERSITY_DETAIL: 'GET_UNIVERSITY_DETAIL',
  GET_UNIVERSITY_DETAIL_CS: 'GET_UNIVERSITY_DETAIL_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_UNIVERSITY_COMMUNICATION_STATUS',
  UPDATE_CS: 'UPDATE_UNIVERSITY_COMMUNICATION_STATUS',
  CHECK_UNIVERSITY_EXIST: 'CHECK_UNIVERSITY_EXIST',
};

export const imageActionTypes = {
  UPDATE_CS: 'UPDATE_IMAGE_COMMUNICATION_STATUS',
  DELETED_CS: 'DELETED_IMAGE_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_IMAGE_COMMUNICATION_STATUS',
};

export const galleryActionTypes = {
  SHRINK_CS: 'SHRINK_GALLERY_MODAL',
};

export const commissionActionTypes = {
  UPDATE_CS: 'UPDATE_COMMISSION_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_COMMISSION_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETE_COMMISSION_COMMUNICATION_STATUS',
  GET_PROPERTY_COMMISSION_TIERS_CS: 'GET_PROPERTY_COMMISSION_TIERS_CS',
  SET_PROPERTY_COMMISSION_TIERS_CS: 'SET_PROPERTY_COMMISSION_TIERS_CS',
};

export const depositActionTypes = {
  UPDATE_CS: 'UPDATE_DEPOSIT_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_DEPOSIT_COMMUNICATION_STATUS',
  DELETE_CS: 'DELETED_DEPOSIT_COMMUNICATION_STATUS',
  UPDATE_PROPERTY_CS: 'UPDATE_PROPERTY_COMMUNICATION_STATUS',
  GET_PROPERTY_DEPOSIT_CS: 'GET_PROPERTY_DEPOSIT_CS',
  SET_PROPERTY_DEPOSIT_CS: 'SET_PROPERTY_DEPOSIT_CS',
};

export const contractActionTypes = {
  UPDATE_CONTRACT_CS: 'UPDATE_CONTRACT_CS',
  CREATE_CONTRACT_CS: 'CREATE_CONTRACT_CS',
  DELETE_CONTRACT_CS: 'DELETE_CONTRACT_CS',
  SET_CONTRACT_LIST: 'SET_CONTRACT_LIST',
  GET_CONTRACT_LIST_CS: 'GET_CONTRACT_LIST_CS',
  BULK_DUALLY_SIGNED_PROPERTY: 'BULK_DUALLY_SIGNED_PROPERTY',
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  SET_LANDLORD_LIST: 'SET_LANDLORD_LIST',
  LANDLORD_SELECTED_CS: 'LANDLORD_SELECTED_CS',
};

export const pendingApprovalActionTypes = {
  SET_PENDING_APPROVAL_LIST: 'SET_PENDING_APPROVAL_LIST',
  GET_PENDING_APPROVAL_LIST_CS: 'GET_PENDING_APPROVAL_LIST_CS',
  GET_PROPERTY_COMMENTS_CS: 'GET_PROPERTY_COMMENTS_CS',
  SET_PROPERTY_COMMENTS: 'SET_PROPERTY_COMMENTS',
  REQUEST_PUBLISH_CS: 'REQUEST_PUBLISH_CS',
};

export const recordActionTypes = {
  GET_PROPERTY_NOTE_CS: 'GET_PROPERTY_NOTE_CS',
  SET_PROPERTY_NOTE_CS: 'SET_PROPERTY_NOTE_CS',
};

export const accountActionTypes = {
  LANDLORD_LIST_CS: 'LANDLORD_LIST_CS',
  GET_LANDLORD_USER_CS: 'GET_LANDLORD_USER_CS',
  SET_CMS_USER: 'SET_CMS_USER',
  UPDATE_CS: 'UPDATE_ACCOUNT_COMMUNICATION_STATUS',
  CREATE_CS: 'CREATE_ACCOUNT_COMMUNICATION_STATUS',
  INITIALIZE: 'INITIALIZE_ACCOUNT_LIST',
  SET_LIST: 'SET_ACCOUNT_LIST',
  LIST_CS: 'GET_LIST_ACCOUNT_LIST_COMMUNICATION_STATUS',
  GET_ACCOUNT_DETAIL_CS: 'GET_ACCOUNT_DETAIL_CS',
};

export const listingManagementActionType = {
  SET_PROPERTY: 'SET_PROPERTY',
  GET_PROPERTY_CS: 'GET_PROPERTY_CS',
  PUBLISH_PROPERTY_CS: 'PUBLISH_PROPERTY_CS',
  GET_PROPERTY_PREVIEW_CS: 'GET_PROPERTY_PREVIEW_CS',
  DELETE_ROOM_CS: 'DELETE_ROOM_CS',
  CREATE_ROOM_CS: 'CREATE_ROOM_CS',
  UPDATE_ROOM_CS: 'UPDATE_ROOM_CS',
  SET_COPY_ROOM_LISTING: 'SET_COPY_ROOM_LISTING',
  CREATE_LISTING_CS: 'CREATE_LISTING_CS',
  DELETE_LISTING_CS: 'DELETE_LISTING_CS',
  UPDATE_LISTING_CS: 'UPDATE_LISTING_CS',
  BULK_UPDATE_LISTING_CS: 'BULK_UPDATE_LISTING_CS',
  BULK_DELETE_LISTING_CS: 'BULK_DELETE_LISTING_CS',
  UPDATE_LISTING_ADMIN_SETTING_CS: 'UPDATE_LISTING_ADMIN_SETTING_CS',
  UPDATE_GALLERY_CS: 'UPDATE_GALLERY_CS',
  SET_COVER_PHOTO_DELETED: 'SET_COVER_PHOTO_DELETED',
  SET_GALLERY_PROPERTY: 'SET_GALLERY_PROPERTY',
  GET_UNIT_TYPE_FACILITIES: 'GET_UNIT_TYPE_FACILITIES',
};

export const withdrawalActionTypes = {
  GET_WITHDRAWAL_METHODS_CS: 'GET_WITHDRAWAL_METHODS_CS',
  SET_WITHDRAWAL_METHODS: 'SET_WITHDRAWAL_METHODS',
  UPDATE_WITHDRAWAL: 'UPDATE_WITHDRAWAL',
  DELETE_WITHDRAWAL: 'DELETE_WITHDRAWAL',
  ADD_WITHDRAWAL: 'INSERT_WITHDRAWAL',
};

export const longtailBookingsActionTypes = {
  GET_LONG_TAIL_BOOKINGS_CS: 'GET_LONG_TAIL_BOOKINGS_CS',
  SET_LONG_TAIL_BOOKINGS: 'SET_LONG_TAIL_BOOKINGS',
  CONFIRM_ORDER_CS: 'CONFIRM_ORDER_CS',
  REJECT_ORDER_CS: 'REJECT_ORDER_CS',
  REJECT_REFUND_CS: 'REJECT_REFUND_CS',
};

export const reconciliationActionTypes = {
  GET_RECONCILIATION_LIST_CS: 'GET_RECONCILIATION_LIST_CS',
  SET_RECONCILIATION_LIST: 'SET_RECONCILIATION_LIST',
  GET_RECONCILIATION_LIST_COUNT_CS: 'GET_RECONCILIATION_LIST_COUNT_CS',
  GET_LANDLORD_PROPERTY_CS: 'GET_LANDLORD_PROPERTY_CS',
  EXPORT_LIST_CS: 'EXPORT_LIST_CS',
  COUNTRY_LIST_CS: 'COUNTRY_LIST_CS',
  CITY_LIST_CS: 'CITY_LIST_CS',
};

export const propertyTermsActionTypes = {
  GET_PROPERTY_TERMS: 'GET_PROPERTY_TERMS_CS',
  SET_PROPERTY_TERMS: 'SET_PROPERTY_TERMS',
  CREATE_PROPERTY_TERMS: 'CREATE_PROPERTY_TERMS_CS',
  UPDATE_PROPERTY_TERMS: 'UPDATE_PROPERTY_TERMS_CS',
  DELETE_PROPERTY_TERMS: 'DELETE_PROPERTY_TERMS_CS',
};
